<template>
  <div>
    <Head :title="__(title)" />
    <div class="flex flex-wrap">
      <div class="max-w-full lg:w-3/5">
        <form class="mr-2 overflow-hidden bg-white rounded-md shadow" @submit.prevent="update">
          <div class="flex flex-wrap p-8 -mb-8 -mr-6">
            <!--Super Admin -->
                        
            <select-edit-input
              v-if="auth.user.role.slug !== 'student'" v-model="form.user_id"
              placeholder="Search customer" :on-input="doFilter" :items="customers" :error="form.errors.user_id"
              class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Customer')" :value="ticket.user"
              :editable="user_access.ticket.update && !ticket.closed && (auth.user.id === form.assigned_to || auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')"
            />

            <select-edit-input
              v-model="form.priority_id" placeholder="Search priority" :items="priorities"
              :error="form.errors.priority_id" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Priority')"
              :value="ticket.priority" :editable="user_access.ticket.update && !ticket.closed && (auth.user.id === form.assigned_to || auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')"
            />
            <select-edit-input
              v-if="!(hidden_fields && hidden_fields.includes('department'))"
              v-model="form.department_id" placeholder="Search department" :items="departments"
              :error="form.errors.department_id" class="w-full pb-8 pr-6 lg:w-1/3"
              :label="__('Department')" :value="ticket.department"
              :editable="user_access.ticket.update && !ticket.closed && (auth.user.id === form.assigned_to || auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')"
            />

            <select-edit-input
              v-if="auth.user.role.slug !== 'student' && !(hidden_fields && hidden_fields.includes('assigned_to'))"
              v-model="form.assigned_to" placeholder="Search user"
              :on-input="doFilterUsersExceptCustomer" :items="usersExceptCustomers" :error="form.errors.assigned_to"
              class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Assigned to')"
              :value="ticket.assigned_user ?? 'Not Assigned'"
              :editable="user_access.ticket.update && !ticket.closed && (auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')"
            />

            <select-edit-input
              v-model="form.status_id" placeholder="Select status to change"
              :items="statuses" :error="form.errors.status_id" class="w-full pb-8 pr-6 lg:w-1/3"
              :label="__('Status')" :value="ticket.status ? ticket.status.name : 'N/A'"
              :editable="auth.user.role.slug !== 'student' && user_access.ticket.update && !ticket.closed && auth.user.id === form.assigned_to || (auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')"
            />

            <select-edit-input
              v-model="form.class_id" placeholder="Select class"
              :items="classes" :error="form.errors.class_id" class="w-full pb-8 pr-6 lg:w-1/3"
              :label="__('Class')" :value="getClassName(ticket.class_id)"
              :editable="user_access.ticket.update && !ticket.closed && (auth.user.id === form.assigned_to || auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')"
            />

            <div v-if="(auth.user.role.slug !== 'student') && (ticket.status_id == 4)" class="w-full pb-8 pr-6 lg:w-1/3">
              <div class="mb-1 text-sm font-bold">Should it expire after 5 days</div>
              <div class="flex gap-3 text-sm font-light">
                <input id="checkbox" v-model="form.expiration_check" type="checkbox" :checked="form.expiration_check" :disabled="form.expiration_check" />
              </div>
            </div>
                        

                        
            <!-- <select-edit-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" placeholder="Search type" :items="types"
                                           v-model="form.type_id" :error="form.errors.type_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Ticket type')"
                                           :value="ticket.type" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input> -->

            <!-- <select-edit-input v-if="!(hidden_fields && hidden_fields.includes('category'))" placeholder="Search category" :items="categories"
                                           v-model="form.category_id" :error="form.errors.category_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Category')"
                                           :value="ticket.category" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input> -->

            <div class="flex flex-col w-full pb-8 pr-5 assigned_user lg:w-1/3">
              <div class="mb-1 text-sm font-bold">{{ __('Created') }} </div>
                            
              <div class="text-sm font-light text-balance whitespace-nowrap">{{ moment(ticket.created_at).format('D[th],MMMM YYYY h:mm a') }}</div>
            </div>

            <text-edit-input
              v-model="form.subject" :editable="user_access.ticket.update && !ticket.closed && auth.user.id === form.assigned_to || (auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr') "
              :value="ticket.subject" :error="form.errors.subject" class="w-full pb-8 pr-6 lg:w-2/3"
              :label="__('Subject')"
            />

            <div class="flex flex-col w-full pb-8 pr-6 assigned_user lg:w-full">
              <div class="flex gap-3 w-25">
                <label class="form-label">{{ __('Request Details') }}</label>
                <icon
                  v-if="!enableEditor && user_access.ticket.update && !ticket.closed && auth.user.id === form.assigned_to || (auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')" name="edit"
                  class="w-4 h-4 mr-1 cursor-pointer" @click="enableEditor = !enableEditor"
                />
              </div>
              <div v-if="!enableEditor" class="text-sm font-light" v-html="ticket.details" />
              <div v-if="enableEditor" class="flex items-center w-25">
                <ckeditor
                  id="ticketDetails" v-model="form.details" :editor="editor"
                  :config="editorConfig"
                />
                <div class="w-4 h-4 cursor-pointer">
                  <icon
                    name="close" class="w-4 h-4 ml-2 cursor-pointer"
                    @click="enableEditor = false"
                  />
                </div>
              </div>
            </div>


            <!-- Super Admin Comment -->
            <input
              ref="file" type="file"
              accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip" class="hidden"
              multiple="multiple" @change="fileInputChange"
            />
            <div class="flex-col w-full pb-8 pr-6 lg:w-full">
              <button
                type="button" class="flex items-center justify-center pb-3 pl-0 border-0 btn"
                @click="fileBrowse"
              >
                <icon name="file" class="flex-shrink-0 h-5 pr-1 fill-gray-400" /> <strong>{{ __('Attach File') }}</strong>
              </button>
              <div
                v-for="(file, fi) in attachments" v-if="attachments.length"
                :key="fi" class="flex items-center justify-between w-full pt-8 pr-6"
              >
                <div class="flex-1 pr-1">
                  {{ file.name }} <span class="text-xs text-gray-500">({{ getFileSize(file.size)
                  }})</span> <a
                    v-if="file.user" class="text-sm"
                    :href="route('users.edit', file.user.id)"
                  >{{ file.user.first_name }} {{
                    file.user.last_name }}</a> at <span class="text-sm">{{ file.created_at }}</span>
                </div>
                <div class="flex items-center justify-end a__buttons ">
                  <button
                    type="button" class="flex items-center btn "
                    @click="downloadAttachment(file)"
                  >
                    {{ __('ClickToView') }}
                  </button>
                  <button
                    type="button" class="flex items-center ml-3 btn"
                    @click="removeAttachment(file, fi)"
                  >
                    {{ __('Remove') }}
                  </button>
                </div>
              </div>
              <div
                v-for="(file, fi) in form.files"
                v-if="form.files.length"
                :key="fi" class="flex items-center justify-between w-full pt-8 pr-6 lg:w-1/2"
              >
                <div class="flex-1 pr-1">
                  {{ file.name }} <span class="text-xs text-gray-500">({{ getFileSize(file.size)
                  }})</span>
                </div>
                <button
                  v-if="ticket.status && !ticket.closed" type="button"
                  class="flex items-center justify-center btn" @click="fileRemove(file, fi)"
                >
                  {{ __('Remove') }}
                </button>
              </div>
            </div>

            <div
              v-if="ticket.status && ticket.closed && ticket.review"
              class="flex items-center w-full pb-8 pr-6 lg:w-1/3"
            >
              <strong>{{ __('Rating') }}: </strong> &nbsp; {{ ticket.review.rating }}
              <p>
                {{ ticket.review.review }}
              </p>
            </div>

            <div
              v-if="ticket.status && ticket.closed && !ticket.review && auth.user.role.slug === 'student'"
              class="flex flex-col w-full"
            >
              <div class="flex flex-col w-full pb-5 assigned_user star__review lg:w-1/3">
                <div class="font-bold">{{ __('How do you rate this support service?') }} </div>
                <div class="pt-5 star-rating">
                  <input id="5-stars" v-model="form.rating" type="radio" name="rating" value="5" />
                  <label for="5-stars" class="star">&#9733;</label>
                  <input id="4-stars" v-model="form.rating" type="radio" name="rating" value="4" />
                  <label for="4-stars" class="star">&#9733;</label>
                  <input id="3-stars" v-model="form.rating" type="radio" name="rating" value="3" />
                  <label for="3-stars" class="star">&#9733;</label>
                  <input id="2-stars" v-model="form.rating" type="radio" name="rating" value="2" />
                  <label for="2-stars" class="star">&#9733;</label>
                  <input id="1-star" v-model="form.rating" type="radio" name="rating" value="1" />
                  <label for="1-star" class="star">&#9733;</label>
                </div>
              </div>
              <textarea-input
                v-model="form.review" :error="form.errors.review"
                class="w-full pb-4 pr-6 lg:w-1/3" :label="__('Feedback')"
              />
              <div class="flex mb-4 lg:w-1/4">
                <button class="btn-indigo" type="submit">
                  {{ __('Submit')
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
            <button
              v-if="user_access.ticket.delete" class="text-red-600 hover:underline" tabindex="-1"
              type="button" @click="destroy"
            >
              {{ __('Delete') }}
            </button>
            <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">
              {{
                __('Save') }}
            </loading-button>
          </div>
        </form>
      </div>
      <div class="max-w-full lg:w-2/5">
        <div class="flex flex-col flex-1 ml-2 overflow-hidden bg-white rounded-md shadow chat-area comment-box">
          <div class="flex-3">
            <div class="flex flex-col pb-3 chat-header">
              <h3 class="text-xl">{{ __('Ticket discussion') }}</h3>
              <p class="text-sm font-light">{{ __('Comment histories for this ticket will be available here.') }}</p>
            </div>
          </div>
          <div class="flex-1 overflow-auto messages reverse__order">
            <div
              v-for="(comment, index) in comments.slice().reverse()" :key="index"
              class="flex mb-4 message"
            >
              <div v-if="comment.user_id !== user.id" class="flex-2">
                <div class="relative w-12 h-12">
                  <span
                    v-if="comment.user" class="w-12 h-12 mx-auto rounded-full user_icon"
                    alt="chat-user"
                  >{{ Array.from(comment.user.first_name)[0] }}</span>
                </div>
              </div>
              <div v-if="comment.user_id !== user.id" class="flex-1 px-2">
                <h3 v-if="comment.user" class="pt-1 pb-2 text-sm font-bold">
                  {{ comment.user.first_name
                  }} {{ comment.user.last_name }}
                </h3>
                <div
                  class="inline-block p-2 px-4 leading-5 text-gray-700 bg-gray-300 user-comment-round"
                >
                  <span>{{ comment.details }}</span>
                </div>
                <div class="pl-4">
                  <small class="text-gray-500">{{
                    moment(comment.updated_at).fromNow(true) }}</small>
                </div>
              </div>

              <div v-if="comment.user_id === user.id" class="flex-1 px-2 text-right">
                <div class="inline-block p-2 px-4 leading-5 text-white rounded-full bg-blue">
                  <span>{{ comment.details }}</span>
                </div>
                <div class="pr-4">
                  <small class="text-gray-500">{{
                    moment(comment.updated_at).fromNow(true) }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-4 pb-3 flex-2">
            <div class="flex bg-white rounded-lg shadow write">
              <!--                            <div class="flex items-center content-center p-4 pr-0 text-center flex-3">-->
              <!--                                            <span class="block text-center text-gray-400 hover:text-gray-800">-->
              <!--                                                <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24" class="w-6 h-6"><path d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>-->
              <!--                                            </span>-->
              <!-- 
                                                       </div>-->


              <div v-if="!ticket.closed && auth.user.id === form.assigned_to || (auth.user.role.slug === 'admin' || auth.user.role.slug === 'mngr')" class="flex-1">
                <textarea
                  v-model="comment" name="message" class="block w-full px-4 py-4 overflow-hidden text-sm bg-transparent outline-none"
                  rows="1"
                  :placeholder="__('Write a comment and press enter to send...')" autofocus
                  @keydown.enter.exact.prevent="submitComment"
                />
              </div>
              <div class="flex items-center content-center p-2 flex-2 w-35">
                <!--                                <div class="flex-1 text-center">-->
                <!--                                                <span class="text-gray-400 hover:text-gray-800">-->
                <!--                                                    <span class="inline-block align-text-bottom">-->
                <!--                                                        <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24" class="w-6 h-6"><path d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path></svg>-->
                <!--                                                    </span>-->
                <!--                                                </span>-->
                <!--                                </div>-->
                <div v-if="!ticket.closed" class="flex-1">
                  <button
                    class="flex items-center justify-center w-10 h-10 rounded-full bg-blue"
                    @click="submitComment"
                  >
                    <icon class="w-4 h-4 fill-gray-100" name="send" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- <div class="max-w-full lg:w-2/5"> -->
        <!-- Email Section -->
      <!-- Email Section: Side by side with form, full screen layout -->
      <div class="flex flex-row w-full mt-3 mb-5">
        <div class="flex-1 mt-4 ml-2 overflow-hidden bg-white rounded-md shadow">
          <div class="p-6">
            <h3 class="flex items-center mb-6 text-xl font-semibold text-blue-700">
              <icon name="mail" class="w-5 h-5 mr-2 text-blue-500" />
              {{ __('Send Ticket Details via Email') }}
            </h3>
            <!-- Email Form -->
            <div v-if="!ticket.closed" class="mb-4">
              <div class="mb-4">
                <label class="block mb-1 text-sm font-medium text-gray-700">Email Address</label>
                <input 
                  v-model="emailForm.email" 
                  type="email" 
                  class="w-full px-3 py-2 transition border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Enter email address"
                  required
                >
                <span v-if="emailForm.errors.email" class="block mt-1 text-xs text-red-500">{{ emailForm.errors.email }}</span>
              </div>
              <div class="mb-4">
                <label class="block mb-1 text-sm font-medium text-gray-700">Additional Message <span class="text-gray-400">(Optional)</span></label>
                <textarea 
                  v-model="emailForm.message" 
                  rows="3"
                  class="w-full px-3 py-2 transition border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Add a custom message..."
                ></textarea>
              </div>
              <button 
                @click="sendTicketEmail"
                :disabled="emailForm.processing || !emailForm.email"
                class="flex items-center justify-center w-full px-4 py-2 font-semibold text-white transition rounded-lg shadow bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 disabled:bg-gray-400"
              >
                <span v-if="!emailForm.processing">
                  <icon name="mail" class="w-4 h-4 mr-2" />
                  Send Email
                </span>
                <span v-else>
                  <svg class="w-4 h-4 mr-2 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Sending...
                </span>
              </button>
            </div>
          </div>
        </div>
        <!-- Email History -->
        <div class="flex-1 mt-4 ml-2 overflow-hidden bg-white rounded-md shadow">
          <div class="flex flex-col h-full p-6">
            <div class="mb-4">
              <h4 class="flex items-center text-lg font-semibold text-blue-700">
                <icon name="history" class="w-5 h-5 mr-2 text-blue-500" />
                Email History
              </h4>
             
            </div>
            <div v-if="ticket_emails && ticket_emails.length > 0" class="flex-1 pr-2 space-y-4 overflow-y-auto max-h-64">
              <div 
                v-for="email in ticket_emails" 
                :key="email.id"
                class="p-4 border-l-4 border-blue-500 rounded-lg shadow-sm bg-blue-50"
              >
                <div class="flex items-start justify-between mb-2">
                  <div>
                    <p class="flex items-center text-sm font-semibold text-blue-800">
                      <icon name="mail" class="w-4 h-4 mr-1 text-blue-400" />
                      {{ email.email }}
                    </p>
                    <p class="text-xs text-gray-600">
                      Sent by <span class="font-medium">{{ email.user.first_name }} {{ email.user.last_name }}</span>
                    </p>
                  </div>
                  <span class="text-xs text-gray-500 whitespace-nowrap">
                    {{ moment(email.sent_at).format('MMM DD, YYYY h:mm A') }}
                  </span>
                </div>
                <p v-if="email.message" class="p-3 mt-2 text-sm text-gray-700 bg-white border border-blue-100 rounded">
                  {{ email.message }}
                </p>
              </div>
            </div>
            <div v-else class="flex flex-col justify-center flex-1 py-8 text-sm text-center text-gray-400">
              <icon name="mail" class="w-8 h-8 mx-auto mb-2 text-gray-300" />
              No emails sent for this ticket yet.
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextEditInput from '@/Shared/TextEditInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import SelectEditInput from '@/Shared/SelectEditInput'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import UploadAdapter from '@/Shared/UploadAdapter'
import moment from 'moment'


export default {
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TextEditInput,
        TextareaInput,
        Link,
        Head,
        Icon,
        SelectInputFilter,
        SelectEditInput,
    },
    layout: Layout,
    props: {
        title: String,
        ticket: Object,
        priorities: Array,
        statuses: Array,
        types: Array,
        departments: Array,
        categories: Array,
        classes: Array,
        customers: Array,
        usersExceptCustomers: Array,
        attachments: Array,
        comments: Array,
        auth: Object,
        hidden_fields: Object,
        ticket_emails: Array,
    },
    remember: false,
    data() {
        return {
            user: this.$page.props.auth.user,
            type_status: [],
            emailForm: {
              email: '',
              message: '',
              processing: false,
              errors: {}
            },
            comment: '',
            editCustomer: false,
            enableEditor: false,
            user_access: this.$page.props.auth.user.access,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo'],
                table: {
                    toolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                extraPlugins: [this.uploader],
            },
            form: this.$inertia.form({
                user_id: this.ticket.user_id,
                priority_id: this.ticket.priority_id,
                status_id: this.ticket.status_id,
                department_id: this.ticket.department_id,
                category_id: this.ticket.category_id,
                class_id: this.ticket.class_id,
                assigned_to: this.ticket.assigned_to,
                type_id: this.ticket.type_id,
                subject: this.ticket.subject,
                details: this.ticket.details,
                files: this.ticket.files,
                comments: this.ticket.comments,
                created_at: this.ticket.created_at,
                expiration_check:this.ticket.expiration_check ? true : false,
                removedFiles: [],
                rating: 0,
                review: '',
            }),
        }
    },
    created() {
        console.log(this.form.status_id)
        if (this.auth.user.role.slug === 'student' && this.statuses.length) {
            this.type_status = this.statuses.filter(status => (status.id === this.form.status_id) || status.name.match(/Close.*/))
        } else {
            this.type_status = this.statuses
        }
        this.moment = moment
    },
    watch: {
        'form.user_id'(newValue) {
            const selectedCustomer = this.customers.find(customer => customer.id === newValue)
            if (selectedCustomer && selectedCustomer.class_id) {
                this.form.class_id = selectedCustomer.class_id
            }
        },
    },
    
    methods: {
        getClassName(classId) {
            if (!classId) return null
            const classItem = this.classes.find(c => c.id === classId)
            return classItem ? classItem.name : null
        },
        uploader(editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return new UploadAdapter(loader)
            }
        },
        doFilter(e) {
            this.axios.get(this.route('filter.customers', { search: e.target.value })).then((res) => {
                this.customers.splice(0, this.customers.length, ...res.data)
            })
        },
        doFilterUsersExceptCustomer(e) {
            this.axios.get(this.route('filter.users_except_customer', { search: e.target.value })).then((res) => {
                this.usersExceptCustomers.splice(0, this.usersExceptCustomers.length, ...res.data)
            })
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i])
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1)
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        downloadAttachment(file) {
            const url = window.location.origin + '/files/' + file.path
            window.open(url, '_blank')
            // const link = document.createElement("a");
            // link.href = window.location.origin + '/files/' + file.path;
            // link.download = file.name;
            // link.click();
        },
        removeAttachment(file, index) {
            this.attachments.splice(index, 1)
            this.form.removedFiles.push(file.id)
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
        },
        uploadFiles() {
            this.form.files = this.$refs.files.files
        },
        update() {
            this.form.post(this.route('tickets.update', this.ticket.id))
            this.form.files = []
            this.form.comment = ''
        },
        destroy() {
            if (confirm('Are you sure you want to delete this ticket?')) {
                this.$inertia.delete(this.route('tickets.destroy', this.ticket.id))
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this ticket?')) {
                this.$inertia.put(this.route('tickets.restore', this.ticket.id))
            }
        },
        submitComment() {
            var that = this
            const messageData = {
                comment: this.comment,
                user_id: this.user.id,
                _token: this.$page.props.csrf_token,
                ticket_id: this.ticket.id,
            }
            this.comment = ''
            this.axios.post(this.route('ticket.comment'), messageData).then((response) => {
                if (response.data) {
                    that.comments.push(response.data)
                }
                this.$emit('comment submitted!')
            }).catch((error) => {
                console.log(error)
            })
        },

        async sendTicketEmail() {
        // Reset errors
        this.emailForm.errors = {};
        
        // Basic validation
        if (!this.emailForm.email) {
            this.emailForm.errors.email = 'Email address is required';
            return;
        }
        
        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.emailForm.email)) {
            this.emailForm.errors.email = 'Please enter a valid email address';
            return;
        }
        
        this.emailForm.processing = true;
        
        try {
            const response = await this.axios.post(
                this.route('tickets.send-email', this.ticket.id),
                {
                    email: this.emailForm.email,
                    message: this.emailForm.message,
                    _token: this.$page.props.csrf_token
                }
            );
            
            if (response.data.success) {
                // Show success message (you can use your preferred notification method)
                alert('Email sent successfully!');
                
                // Add the new email to the beginning of the history array
                if (response.data.new_email) {
                    this.ticket_emails.unshift(response.data.new_email);
                }
                
                // Clear form
                this.emailForm.email = '';
                this.emailForm.message = '';
            }
        } catch (error) {
            console.error('Error sending email:', error);
            
            if (error.response && error.response.data.errors) {
                this.emailForm.errors = error.response.data.errors;
            } else {
                alert('Failed to send email. Please try again.');
            }
        } finally {
            this.emailForm.processing = false;
        }
    },
    
    async refreshEmailHistory() {
        try {
            const response = await this.axios.get(
                this.route('tickets.email-history', this.ticket.id)
            );
            
            if (response.data.success) {
                this.ticket_emails = response.data.ticket_emails;
            }
        } catch (error) {
            console.error('Error refreshing email history:', error);
        }
    }
    },
}
</script>
